import React, { useMemo } from 'react';
import { Chart } from 'primereact/chart';
import { useSelector, useDispatch } from 'react-redux';
import { loadModuleQuestionsAsync, selectModuleQuestions } from '../dashboardSlice';
import { ChartCard } from './ChartCard';
import { useThemeVersion, getStoredColorMode } from '../../../useTheme';
import { categoryColor } from '../categoryColors';

export const ModuleQuestionsChart = () => {
    const dispatch = useDispatch();
    const { data, status, error } = useSelector(selectModuleQuestions);
    // getComputedStyle abaixo só lê o CSS de novo se essa memo recalcular —
    // sem isso, trocar de tema depois de montado deixa a cor antiga presa.
    const themeVersion = useThemeVersion();

    const chartData = useMemo(() => {
        const color = categoryColor('module', getStoredColorMode());
        if (!Array.isArray(data) || !data.length) {
            return {
                labels: [],
                datasets: [{
                    label: 'Questões por módulo',
                    data: [],
                    backgroundColor: color,
                    borderColor: color
                }]
            };
        }

        const moduleCount = {};
        data.forEach(question => {
            const module = question.moduleName || 'Sem módulo';
            moduleCount[module] = (moduleCount[module] || 0) + question.questionCount;
        });

        return {
            labels: Object.keys(moduleCount),
            datasets: [{
                label: 'Questões por módulo',
                data: Object.values(moduleCount),
                backgroundColor: color,
                borderColor: color,
                borderWidth: 1
            }]
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, themeVersion]);

    const chartOptions = useMemo(() => ({
        plugins: {
            legend: {
                labels: {
                    color: getComputedStyle(document.documentElement).getPropertyValue('--text-color')
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    color: getComputedStyle(document.documentElement).getPropertyValue('--text-color')
                },
                grid: {
                    color: getComputedStyle(document.documentElement).getPropertyValue('--surface-border')
                }
            },
            x: {
                ticks: {
                    color: getComputedStyle(document.documentElement).getPropertyValue('--text-color')
                },
                grid: {
                    color: getComputedStyle(document.documentElement).getPropertyValue('--surface-border')
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [themeVersion]);

    return (
        <ChartCard
            title="Questões por módulo"
            loading={status === 'loading'}
            error={error}
            onReload={() => dispatch(loadModuleQuestionsAsync())}
        >
            {/* <div style={{ minHeight: '200px' }}> */}
                <Chart type="bar" data={chartData} options={chartOptions} />
            {/* </div> */}
        </ChartCard>
    );
}; 